export function getValue(value, titles) {
  return titles.find(t => t.id === value)?.text || ''
}
